module.exports = "/_next/static/images/power-dac4fe79e607b6f07cec48a5d526c1fb.png.webp";